import ApiBaseURLProps from "../other/apiBaseURL";
import { getAxios, postAxios, putAxios } from "./apiConfig";

const VideoApiService = {
  save: (obj) => {
    return postAxios(ApiBaseURLProps.apiBaseURL + "/video-kyc/event", obj);
  },
  update: (id, obj) => {
    return postAxios(ApiBaseURLProps.apiBaseURL + "/video-kyc/event" + id, obj);
  },
  updateCheck: (obj) => {
    return putAxios(ApiBaseURLProps.apiBaseURL + "/video-kyc/check", obj);
  },
  analyze: (id) => {
    return putAxios(ApiBaseURLProps.apiBaseURL + "/video-kyc/analyze/" + id);
  },
  get: (id) => {
    return getAxios(ApiBaseURLProps.apiBaseURL + "/video-kyc/customer/" + id);
  },
  getAll: () => {
    return getAxios(ApiBaseURLProps.apiBaseURL + "/video-kyc/list");
  },
}

export default VideoApiService;
